export const ADD_ATTENDENCE_REQUEST = 'ADD_ATTENDENCE_REQUEST'
export const ADD_ATTENDENCE_SUCCESS = 'ADD_ATTENDENCE_SUCCESS'
export const ADD_ATTENDENCE_FALIURE = 'ADD_ATTENDENCE_FALIURE'
